import styled from 'styled-components';

const HEADER_TEXT = '#1F2D3D';
const TOGGLE_BG = '#F1F3F5';

export const Container = styled.div`
  .user-center-toggle:focus,
  .user-center-toggle:active {
    outline: none;
    box-shadow: none;
  }
`;

export const UserCard = styled.div`
  border: 1px solid ${({ theme }) => theme.$gray300};
  border-radius: 6px;
  overflow: hidden;
  margin-bottom: 0.5rem;
`;

export const ToggleButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  border: 0;
  padding: 0.75rem 1rem;
  background: ${TOGGLE_BG};
  cursor: pointer;
  text-align: left;
`;

export const UserName = styled.span`
  font-weight: bold;
  color: ${HEADER_TEXT};
`;

export const SubtleBadge = styled.span`
  font-size: 11px;
  color: ${({ theme }) => theme.$gray600};
  background: ${({ theme }) => theme.$gray200};
  padding: 2px 8px;
  border-radius: 10px;
  font-weight: 500;
  margin-left: 0.5rem;
`;

export const Chevron = styled.i<{ $isOpen: boolean }>`
  font-size: 22px;
  color: ${({ theme }) => theme.$gray600};
  transition: transform 0.2s;
  transform: rotate(${({ $isOpen }) => ($isOpen ? 180 : 0)}deg);
`;

export const PanelBody = styled.div<{ $isOpen: boolean }>`
  display: ${({ $isOpen }) => ($isOpen ? 'block' : 'none')};
  background: ${({ theme }) => theme.$white};
  padding: 0.75rem 1rem;
`;
